import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useFindRegionsByZipCode } from '@/features/regions/hooks/useRegions';
import { RegionTable } from '../RegionTable';
import { toast } from 'sonner';

export function ZipCodeSearch() {
  const [zipCode, setZipCode] = useState('');
  const [searchedZip, setSearchedZip] = useState('');
  const { data: regions, isLoading, error } = useFindRegionsByZipCode(searchedZip);

  const handleSearch = () => {
    if (!zipCode.trim()) {
      toast.error('Please enter a zip code');
      return;
    }
    setSearchedZip(zipCode.trim());
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Find Regions by Zip Code</CardTitle>
          <CardDescription>
            Enter a zip code to find regions that serve that area
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center space-x-2">
            <Input
              placeholder="Enter zip code..."
              value={zipCode}
              onChange={(e) => setZipCode(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            />
            <Button onClick={handleSearch}>Search</Button>
          </div>
        </CardContent>
      </Card>

      {searchedZip && (
        <Card>
          <CardHeader>
            <CardTitle>Results for zip code: {searchedZip}</CardTitle>
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <div className="flex justify-center p-4">Loading...</div>
            ) : error ? (
              <div className="text-red-500 p-4">
                Error loading regions: {error instanceof Error ? error.message : 'Unknown error'}
              </div>
            ) : regions && regions.length > 0 ? (
              <RegionTable regions={regions} />
            ) : (
              <div className="text-center p-4">
                No regions found for zip code {searchedZip}
              </div>
            )}
          </CardContent>
        </Card>
      )}
    </div>
  );
}

// Also provide a default export
export default ZipCodeSearch; 